// Small pill/badge shared by the CRM panels of the lead aside (LeadTickets,
// LeadTimeline). Extracted from LeadTickets so both panels render status chips
// with one palette instead of cloning the component.

export type PillScheme = "muted" | "blue" | "green" | "amber" | "purple";

const PILL_COLORS: Record<
  PillScheme,
  { background: string; color: string; borderColor: string }
> = {
  muted: { background: "#f1f3f5", color: "#495057", borderColor: "#dee2e6" },
  blue: { background: "#dbeafe", color: "#1d4ed8", borderColor: "#bfdbfe" },
  green: { background: "#d4edda", color: "#155724", borderColor: "#c3e6cb" },
  amber: { background: "#fff3cd", color: "#856404", borderColor: "#ffeeba" },
  purple: { background: "#ede7fb", color: "#5f3dc4", borderColor: "#d0bfff" },
};

export default function Pill({
  label,
  scheme,
}: {
  label: string;
  scheme: PillScheme;
}) {
  return (
    <span
      style={{
        display: "inline-block",
        padding: "0.1rem 0.45rem",
        borderRadius: "0.4rem",
        fontSize: ".68rem",
        fontWeight: 600,
        border: "1px solid",
        ...PILL_COLORS[scheme],
      }}
    >
      {label}
    </span>
  );
}
